// extracted by mini-css-extract-plugin
module.exports = {"appBar":"header_appBar__3kN8N","toolbar":"header_toolbar__TjjNx","logoIcon":"header_logoIcon__1QtoO","title":"header_title__1X5yb"};